var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 17,
    viewBox: "0 0 80 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3570_1347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    transform: "translate(0 0.994141)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0003 9.32682C44.1844 9.32682 44.3337 9.17758 44.3337 8.99349C44.3337 8.80939 44.1844 8.66016 44.0003 8.66016C43.8162 8.66016 43.667 8.80939 43.667 8.99349C43.667 9.17758 43.8162 9.32682 44.0003 9.32682Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 9.32682C40.1844 9.32682 40.3337 9.17758 40.3337 8.99349C40.3337 8.80939 40.1844 8.66016 40.0003 8.66016C39.8162 8.66016 39.667 8.80939 39.667 8.99349C39.667 9.17758 39.8162 9.32682 40.0003 9.32682Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0003 9.32682C36.1844 9.32682 36.3337 9.17758 36.3337 8.99349C36.3337 8.80939 36.1844 8.66016 36.0003 8.66016C35.8162 8.66016 35.667 8.80939 35.667 8.99349C35.667 9.17758 35.8162 9.32682 36.0003 9.32682Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3570_1347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    fill: "white",
    transform: "translate(0 0.994141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrapper);
export default __webpack_public_path__ + "static/media/iconWrapper.740f9a60f8851459aefe97b7c635e92c.svg";
export { ForwardRef as ReactComponent };